import { Client } from "@gadget-client/getsimio";

export const api = new Client({ environment: window.gadgetConfig.environment });
